import { Grid } from "@mui/material";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { LocaleContext } from "../../routing/LangRouter";
import { t } from "i18next";

function RulesLink() {
    //general variables
    const { locale } = useContext(LocaleContext);
    return (
        <Grid>
            {locale === "en" ? (
                <Grid container item xs="auto">
                    <span>
                        By clicking the 'Submit Information' button,you agree to the{" "}
                        <Link className="rules__rules-link" target="_blank" to={`/${locale}/rules`}>
                            site's terms and conditions
                        </Link>
                        .
                    </span>
                </Grid>
            ) : (
                <Grid container item xs="auto">
                    <span>
                        {t("agreeToTerms")}
                        <Link className="rules__rules-link" target="_blank" to={`/${locale}/rules`}>
                            {t("siteRules")}
                        </Link>{" "}
                        موافقت کرده اید.
                    </span>
                </Grid>
            )}
        </Grid>
    );
}

export default RulesLink;
